<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('addEditTourneeModele.ajoutFace.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button" @click="$router.go(-1)">
                {{$t('general.button.return')}}
              </button>
              <button class="button is-addOrEdit mgl-10px" @click="ajoutFaceTournee">
                {{$t('general.button.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <liste-patrimoine
      v-if="mountedLoadingEnd"
      ref="faceSelector"
      :type-patrimoine="constantes.FACE"
      :patrimoine-associated="facesAssociated"/>
  </div>
</template>

<script>

import breadcrumb from '@/components/general/breadcrumb';
import listePatrimoine from '@/components/gabed/general/l_patrimoine';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { SET_TOURNEE_MODELE, SET_MESSAGE_INFO } from '@/store/modules/logistique/tourneeModele-mutation-type';
import { getTourneeLigneFromFacePatriListe } from '@/services/logistique/tourneeModele/addEditTourneeModele/getTourneeLigneFromFacePatri';
import { FACE } from '@/configuration/gabed/emplacement/emplacementConf';
import { getAll } from '@/api/gabed/face';

const Societe = createNamespacedHelpers('societe');
const TourneeModele = createNamespacedHelpers('tourneeModele');

export default {
  name: 'l_ajoutFace',
  data() {
    return {
      constantes: {
        FACE,
      },
      facesAssociated: [],
      messageInfo: [],
      mountedLoadingEnd: false,
    };
  },
  components: {
    breadcrumb,
    listePatrimoine,
  },
  computed: {
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('addEditTourneeModele.ajoutFace.breadcrumb.home'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('addEditTourneeModele.ajoutFace.breadcrumb.liste'), route: { name: 'l.logistique.tournee_modele' }, isActive: false },
        { title: this.$i18n.t('addEditTourneeModele.ajoutFace.breadcrumb.add'), route: { name: 'm.logistique.tournee_modele-ajout' }, isActive: false },
        { title: this.$i18n.t('addEditTourneeModele.ajoutFace.breadcrumb.addFace'), route: '', isActive: true },
      ];
      if (this.tourneeModele?.id) {
        output[2].title = this.$i18n.t('addEditTourneeModele.ajoutFace.breadcrumb.edit');
        output[2].route = { name: 'm.logistique.tournee_modele-edit', params: { id: this.tourneeModele.id } };
      }
      return output;
    },
    ...TourneeModele.mapGetters({
      tourneeModele: 'tourneeModele',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...TourneeModele.mapMutations({
      setTournee: SET_TOURNEE_MODELE,
      setMessageInfo: SET_MESSAGE_INFO,
    }),
    getOrdre() {
      let ordre = 10;
      this.tourneeModele.tourneeLignes.forEach((tourneeLigne) => {
        if (Number(tourneeLigne.ordre) >= ordre) ordre = Number(tourneeLigne.ordre) + 10;
      });
      return ordre;
    },
    async ajoutFaceTournee() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const facesSelected = await this.$refs.faceSelector.loadFacesSelection();
        const newfacesSelected = facesSelected.filter(face => !this.tourneeModele.tourneeLignes
          .some(tourneeLigne => tourneeLigne.faceId === face.id));
        if (newfacesSelected.length > 0) {
          this.tourneeModele.tourneeLignes = this.tourneeModele.tourneeLignes.concat(
            await getTourneeLigneFromFacePatriListe(
              newfacesSelected, this.getOrdre(), this.$i18n,
              this.societeActiveId, this.messageInfo,
            ),
          );
          this.setMessageInfo(this.messageInfo);
        }
        this.tourneeModele.tourneeLignes.sort((a, b) => {
          return a.ordre - b.ordre;
        });
        this.setTournee(this.tourneeModele);
        loadingComponent.close();
        if (this.tourneeModele.id) {
          await this.$router.push({
            name: 'm.logistique.tournee_modele-edit',
            params: { id: this.tourneeModele.id },
          });
        } else {
          await this.$router.push({
            name: 'm.logistique.tournee_modele-ajout',
          });
        }
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.tourneeModele) {
        this.setMessageInfo(this.messageInfo);
        this.setInformationPage(this.$t('pageLogistique.tourneeModele.ajoutFace'));
        const faceIds = this.tourneeModele.tourneeLignes.map(tourneeLigne => tourneeLigne.faceId);
        if (faceIds.length > 0) {
          this.facesAssociated = (await getAll({
            query: {
              societeId: this.societeActiveId,
              ids: faceIds,
            },
          })).data.result.items;
        }
        this.mountedLoadingEnd = true;
      } else this.$router.go(-2);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
